import type { WidenMediaElement } from '@hub/libs/widen-utils';
import { MediaElementType } from '@hub/libs/widen-utils';
import { useBreakpoints } from '@hub/hooks/useBreakpoints';
import classNames from 'classnames';
import { WidenImage } from '@hub/common/Widen/WidenImage';

export interface ProductMediaThumbsProps {
  activeIndex: number;
  media: WidenMediaElement[];
  onChange?: (idx: number) => void;
}

export const ProductMediaThumbs = ({ activeIndex, media, onChange }: ProductMediaThumbsProps) => {
  const { lg } = useBreakpoints();
  const width = lg ? 55 : 65;
  const height = lg ? 35 : 43;

  return (
    <div className="relative">
      <div className="relative mx-5 flex flex-row justify-center" data-testid="product-image-thumbs">
        {media.map((img, idx) => (
          <div
            className={classNames(
              'cursor-pointer border-gray-200 relative mx-1',
              activeIndex === idx ? 'border-4' : 'border'
            )}
            data-testid="product-image-thumb"
            onClick={() => {
              onChange && onChange(idx);
            }}
            key={`thumb-image-${img.shortCode}`}
          >
            <WidenImage
              width={width}
              height={height}
              alt={img.description || img.title}
              shortCode={img.shortCode}
              filename={img.filename}
              layout="fixed"
              title={img.title}
              priority={img.priority}
              isVideo={img.type === MediaElementType.VIDEO}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
